function Step6({ formData, errors, onChange }) {

  // Función para bloquear físicamente la pulsación de números (0-9) en el teclado
  // Solo permite letras, espacios, tildes y ñ
  const blockNumbers = (e) => {
    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/;

    // Permitir teclas de control
    if (
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key === "Tab" ||
      e.key === "ArrowLeft" ||
      e.key === "ArrowRight" ||
      e.key === "Home" ||
      e.key === "End"
    ) {
      return;
    }

    if (!regex.test(e.key)) {
      e.preventDefault();
    }
  };

  // Función para evitar que el usuario copie y pegue texto que contenga números
  const blockNumbersOnPaste = (e) => {
    const texto = e.clipboardData.getData("text");
    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/;

    if (!regex.test(texto)) {
      e.preventDefault();
    }
  };
  return (
    <div className="step-panel">

      <div className="field-group">
        <label>
          Cabeza de Hogar <span className="required">*</span>
        </label>
        <div className="radio-group">
          <label className="radio-option">
            <input
              type="radio"
              name="cabezaHogar"
              value="SI"
              checked={formData.cabezaHogar === 'SI'}
              onChange={onChange}
            />
            Sí
          </label>

          <label className="radio-option">
            <input
              type="radio"
              name="cabezaHogar"
              value="NO"
              checked={formData.cabezaHogar === 'NO'}
              onChange={onChange}
            />
            No
          </label>
        </div>
        {errors.cabezaHogar && <span className="field-error">{errors.cabezaHogar}</span>}
      </div>
      
      <div className="field-group">
        <label htmlFor="numeroHijos">
          Número de Hijos <span className="required">*</span>
        </label>
        <input
          id="numeroHijos"
          name="numeroHijos"
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={formData.numeroHijos}
          onChange={(e) => {
            const value = e.target.value.replace(/[^0-9]/g, "");

            onChange({
              target: {
                name: "numeroHijos",
                value,
              },
            });
          }}
          placeholder="Ingrese el número de hijos"
        />
        {errors.numeroHijos && (<span className="field-error">{errors.numeroHijos}</span>)}
      </div>

       <div className="field-group">
        <label>
          Incluir Beneficiarios <span className="required">*</span>
        </label>
        <div className="radio-group">
          <label className="radio-option">
            <input
              type="radio"
              name="incluirBeneficiarios"
              value="SI"
              checked={formData.incluirBeneficiarios === 'SI'}
              onChange={onChange}
            />
            Sí
          </label>

          <label className="radio-option">
            <input
              type="radio"
              name="incluirBeneficiarios"
              value="NO"
              checked={formData.incluirBeneficiarios === 'NO'}
              onChange={onChange}
            />
            No
          </label>
        </div>
        {errors.incluirBeneficiarios && <span className="field-error">{errors.incluirBeneficiarios}</span>}
      </div>

      {formData.incluirBeneficiarios === 'SI' && (
        <div className="field-group">
          <label>Cantidad de Beneficiarios</label>

          <select
            name="cantidadBeneficiarios"
            value={formData.cantidadBeneficiarios}
            onChange={onChange}
          >
            <option value="">Seleccione...</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
          </select>
          {errors.cantidadBeneficiarios && <span className="field-error">{errors.cantidadBeneficiarios}</span>}
        </div>
      )}

      {formData.incluirBeneficiarios === 'SI' && (

        <div className="field-group">
        <label htmlFor="afiliara">
          Afiliar Beneficiarios a? <span className="required">*</span>
        </label>
        <select
          id="afiliara"
          name="afiliara"
          value={formData.afiliara}
          onChange={onChange}
        >
          <option value="">Select an option ...</option>
          <option value="salud">Salud</option>
          <option value="caja de compensacion">Caja de Compensación</option>
          <option value="ambas">Ambas</option>
        
        </select>
        {errors.afiliara && <span className="field-error">{errors.afiliara}</span>}
      </div>

      )}
 

      {Number(formData.cantidadBeneficiarios) >= 1 && (
        <>
          <div className="field-group">
            <label>Nombre del Beneficiario</label>

            <input
              type="text"
              name="beneficiario1Nombre"
              value={formData.beneficiario1Nombre}
              onChange={onChange}
              onKeyPress={blockNumbers}       // Bloquea la escritura de números en tiempo real
              onPaste={blockNumbersOnPaste} 
            />
            {errors.beneficiario1Nombre && <span className="field-error">{errors.beneficiario1Nombre}</span>}
          </div>

          <div className="field-group">
            <label>Parentesco</label>

            <input
              type="text"
              name="beneficiario1Parentesco"
              value={formData.beneficiario1Parentesco}
              onKeyPress={blockNumbers}       // Bloquea la escritura de números en tiempo real
              onPaste={blockNumbersOnPaste} 
              onChange={onChange}
            />
            {errors.beneficiario1Parentesco && <span className="field-error">{errors.beneficiario1Parentesco}</span>}
          </div>
        </>
      )}

      {Number(formData.cantidadBeneficiarios) >= 2 && (
        <>
          <div className="field-group">
            <label>Nombre del Segundo Beneficiario</label>

            <input
              type="text"
              name="beneficiario2Nombre"
              value={formData.beneficiario2Nombre}
              onKeyPress={blockNumbers}       // Bloquea la escritura de números en tiempo real
              onPaste={blockNumbersOnPaste}
              onChange={onChange}
            />
            {errors.beneficiario2Nombre && <span className="field-error">{errors.beneficiario2Nombre}</span>}
          </div>

          <div className="field-group">
            <label>Parentesco del Segundo Beneficiario</label>

            <input
              type="text"
              name="beneficiario2Parentesco"
              value={formData.beneficiario2Parentesco}
              onKeyPress={blockNumbers}       // Bloquea la escritura de números en tiempo real
              onPaste={blockNumbersOnPaste}
              onChange={onChange}
            />
            {errors.beneficiario2Parentesco && <span className="field-error">{errors.beneficiario2Parentesco}</span>}
          </div>
        </>
      )}

      {Number(formData.cantidadBeneficiarios) >= 3 && (
        <>
          <div className="field-group">
            <label>Nombre del Tercer Beneficiario</label>

            <input
              type="text"
              name="beneficiario3Nombre"
              value={formData.beneficiario3Nombre}
              onKeyPress={blockNumbers}
              onPaste={blockNumbersOnPaste}
              onChange={onChange}
            />
            {errors.beneficiario3Nombre && <span className="field-error">{errors.beneficiario3Nombre}</span>}
          </div>

          <div className="field-group">
            <label>Parentesco del Tercer Beneficiario</label>

            <input
              type="text"
              name="beneficiario3Parentesco"
              value={formData.beneficiario3Parentesco}
              onKeyPress={blockNumbers}
              onPaste={blockNumbersOnPaste}
              onChange={onChange}
            />
            {errors.beneficiario3Parentesco && <span className="field-error">{errors.beneficiario3Parentesco}</span>}
          </div>
        </>
      )}

      {Number(formData.cantidadBeneficiarios) >= 4 && (
        <>
          <div className="field-group">
            <label>Nombre del Cuarto Beneficiario</label>

            <input
              type="text"
              name="beneficiario4Nombre"
              value={formData.beneficiario4Nombre}
              onKeyPress={blockNumbers}
              onPaste={blockNumbersOnPaste}
              onChange={onChange}
            />
            {errors.beneficiario4Nombre && <span className="field-error">{errors.beneficiario4Nombre}</span>}
          </div>

          <div className="field-group">
            <label>Parentesco del Cuarto Beneficiario</label>

            <input
              type="text"
              name="beneficiario4Parentesco"
              value={formData.beneficiario4Parentesco}
              onKeyPress={blockNumbers}
              onPaste={blockNumbersOnPaste}
              onChange={onChange}
            />
            {errors.beneficiario4Parentesco && <span className="field-error">{errors.beneficiario4Parentesco}</span>}
          </div>
        </>
      )}

      {Number(formData.cantidadBeneficiarios) >= 5 && (
        <>
          <div className="field-group">
            <label>Nombre del Quinto Beneficiario</label>

            <input
              type="text"
              name="beneficiario5Nombre"
              value={formData.beneficiario5Nombre}
              onKeyPress={blockNumbers}
              onPaste={blockNumbersOnPaste}
              onChange={onChange}
            />
            {errors.beneficiario5Nombre && <span className="field-error">{errors.beneficiario5Nombre}</span>}
          </div>

          <div className="field-group">
            <label>Parentesco del Quinto Beneficiario</label>

            <input
              type="text"
              name="beneficiario5Parentesco"
              value={formData.beneficiario5Parentesco}
              onKeyPress={blockNumbers}
              onPaste={blockNumbersOnPaste}
              onChange={onChange}
            />
            {errors.beneficiario5Parentesco && <span className="field-error">{errors.beneficiario5Parentesco}</span>}
          </div>
        </>
      )}

      {Number(formData.cantidadBeneficiarios) >= 6 && (
        <>
          <div className="field-group">
            <label>Nombre del Sexto Beneficiario</label>

            <input
              type="text"
              name="beneficiario6Nombre"
              value={formData.beneficiario6Nombre}
              onKeyPress={blockNumbers}
              onPaste={blockNumbersOnPaste}
              onChange={onChange}
            />
            {errors.beneficiario6Nombre && <span className="field-error">{errors.beneficiario6Nombre}</span>}
          </div>

          <div className="field-group">
            <label>Parentesco del Sexto Beneficiario</label>

            <input
              type="text"
              name="beneficiario6Parentesco"
              value={formData.beneficiario6Parentesco}
              onKeyPress={blockNumbers}
              onPaste={blockNumbersOnPaste}
              onChange={onChange}
            />
            {errors.beneficiario6Parentesco && <span className="field-error">{errors.beneficiario6Parentesco}</span>}
          </div>
        </>
      )}

    </div>
  );
}

export default Step6;